export default __webpack_public_path__ + "static/media/worst.df1430da.png";